import { useRecoilValue } from "recoil";
import { userOrganization } from "../../../store/layout";
import { EncapsulatedFeatureKeys } from "@lyfegen-platform/graphql-schema/models";

export const useBusinessCaseFeature = () => {
	const organization = useRecoilValue(userOrganization);
	const isBusinessCaseEnabled = organization.encapsulatedFeatures.some(
		(feature) => feature.isEnabled && feature.ofType.key === EncapsulatedFeatureKeys.SimulatorBusinessCase
	);

	return { isBusinessCaseEnabled };
};
